<template>
	<div id="main-gallery">
		<div class="container-fluid container-xl">

			<div class="row justify-content-center">
				<div class="col-12 text-center mb-2 mt-3">
					<h2 class="fs-1-7">Guarda i video</h2>
				</div>
				<div class="col-lg-8 col-xl-5 text-center mt-4">
					<form class="d-flex justify-content-center" @submit.prevent="gallerySearch" v-if="gallery.elements.length">
							<input type="text" class="form-control mb-2 mr-1 mr-md-2" id="search" placeholder="Cerca la tua scuola" v-model="gallery.search">
							<button type="submit" class="btn btn-white-bordered rounded-pill btn-sm px-3 mb-2">VAI</button>
					</form>
				</div>
			</div>

			<div id="gallery-container" class="row pt-5 justify-content-center" v-if="gallery.elements.length">
				<div class="col-sm-8 col-md-6 col-lg-3 mb-4" v-for="(elm, index) in gallery.elements" :key="index">

					<div class="row">
						<div class="col-12">
							<div class="vid-container" :style="{backgroundImage: 'url(' + themeUrl + 'img/cell/' + elm.cornice + ')'}">
								<div class="vid-inner">
									<div class="vid-inner-inner">

										<video-source-component
											:videoURLs="elm.url_video"
											:resolution="resolution.max"
										></video-source-component>

									</div>
								</div>
							</div>
						</div>

						<div class="col-12 mt-1">
							<p class="wrk-title text-center fs-0-8 mb-0">{{elm.title}}</p>
						</div>
						<div class="col-12 mt-1">
							<p class="wrk-school text-center fs-0-6 mb-0">Scuola: {{elm.nome}}</p>
						</div>
						<div class="col-12 mt-1">
							<p class="wrk-class text-center fs-0-8 mb-0">Classe: {{elm.classe}}°{{elm.sezione}}</p>
						</div>
						<div class="col-12 mt-2">
							<like-heart-component
								:wrkId="elm.id"
								:ajaxObj="ajaxObj"
								:year-str="yearStr"
							></like-heart-component>
						</div>
					</div>

				</div>
			</div>

			<div id="gallery-container-2" class="row pt-5 justify-content-center mb-5" v-else>
				<div class="col-sm-10 text-center">
					<p class="fs-1-5 text-grey" v-html="msgGallery1"></p>
					<button class="btn btn-black rounded-pill px-4" v-if="gallery.search"><span class="va-m" @click="resetSearch('1')">OK</span></button>
				</div>
			</div>


			<div class="row">
				<div class="col-12 text-center my-4">
					<button class="btn btn-black rounded-pill" v-if="!gallery.isEnd"><span class="va-m" @click="loadMore">MOSTRA DI PIÙ</span> <i class="fas fa-cog fa-spin va-m fs-1-2 mb-1 ml-1" :class="{'d-none': !isLoading}"></i></button>
				</div>
			</div>

		</div>

		<div class="container-fluid">
			<div class="row">
				<div class="col-12 m-0">
					<hr class="white">
				</div>
			</div>
		</div>

		<div id="text-gallery-container" class="container-fluid container-xl"> <!-- *** TEXT Gallery *********************************************** -->

			<div class="row justify-content-center">
				<div class="col-12 text-center mb-2 mt-3">
					<h2 class="fs-1-7">Leggi le frasi</h2>
				</div>
				<div class="col-lg-8 col-xl-5 text-center mt-4">
					<form class="d-flex justify-content-center" @submit.prevent="textGallerySearch" v-if="textGallery.elements.length">
							<input type="text" class="form-control mb-2 mr-1 mr-md-2" id="search" placeholder="Cerca la tua scuola" v-model="textGallery.search">
							<button type="submit" class="btn btn-white-bordered rounded-pill btn-sm px-3 mb-2">VAI</button>
					</form>
				</div>
			</div>

			<div id="text-gallery" class="row pt-5 justify-content-center" v-if="textGallery.elements.length">
				<div class="col-sm-8 col-md-6 col-lg-3 mb-4" v-for="(elm, index) in textGallery.elements" :key="index">

					<div class="row">
						<div class="col-12">
							<div class="pack-container">
								<img :src="elm.pack" class="img-fluid w-100" alt="">
							</div>
							<div class="pack-text-container position-relative w-100 p-3 d-flex align-items-center" :style="'background-color:' + elm.pack_color+ ';'" style="margin-top:-1px;">
								<div class="pack-text-inner px-2 text-center w-100 d-flex align-items-center justify-content-center" style="background-color:#ffffff;border: 6px solid #000000;color:#000000;min-height:120px;padding-top:3px;padding-bottom:3px;">
									<p class="my-0 bold" v-html="elm.text" style="line-height:1.1;"></p>
								</div>
							</div>
						</div>

						<div class="col-12 mt-1">
							<p class="wrk-school text-center fs-0-6 mb-0">Scuola: {{elm.nome}}</p>
						</div>
						<div class="col-12 mt-1">
							<p class="wrk-class text-center fs-0-8 mb-0">Classe: {{elm.classe}}°{{elm.sezione}}</p>
						</div>
						<div class="col-12 mt-2">
							<like-heart-component
								:wrkId="elm.id"
								:ajaxObj="ajaxObj"
								:year-str="yearStr"
							></like-heart-component>
						</div>
					</div>

				</div>
			</div>

			<div id="gallery-text-container-2" class="row pt-5 justify-content-center mb-5" v-else>
				<div class="col-sm-10 text-center">
					<p class="fs-1-5 text-grey" v-html="msgGallery2"></p>
					<button class="btn btn-black rounded-pill px-4" v-if="textGallery.search != ''"><span class="va-m" @click="resetSearch('2')">OK</span></button>
				</div>
			</div>

			<div class="row">
				<div class="col-12 text-center mt-4 mb-5">
					<button class="btn btn-black rounded-pill" v-if="!textGallery.isEnd"><span class="va-m" @click="loadMoreTextGallery">MOSTRA DI PIÙ</span> <i class="fas fa-cog fa-spin va-m fs-1-2 mb-1 ml-1" :class="{'d-none': !isLoadingTwo}"></i></button>
				</div>
			</div>

		</div>

	</div>
</template>

<script>
import axios from 'axios'
const jQuery = window.jQuery
import { urlBase, themeDir } from '../../variables.js'
import VideoSourceComponent from './VideoSourceComponent.vue'
import LikeHeartComponent from './LikeHeartComponent.vue'

export default {
	components: {VideoSourceComponent, LikeHeartComponent},
	name: 'GalleryComponent',
	props: ['yearStr'],

	data() {
		return {
			ajaxObj: window.ajax_object,
			themeUrl: '',
			bgUrl: '',
			gallery: {
				xpage: '8',
				pageNo: 1,
				search: '',
				elements: [],
				isEnd: false
			},
			textGallery: {
				xpage: '8',
				pageNo: 1,
				search: '',
				elements: [],
				isEnd: false
			},
			resolution: {
				max: (window.screen.availWidth > window.screen.availHeight) ? window.screen.availWidth : window.screen.availHeight
			},
			isLoading: false,
			isLoadingTwo: false,
			msgGallery1: '',
			msgGallery2: ''
		}
	},

	methods: {
		getGalleryElements() {
			let url = this.ajaxObj.ajax_url
			this.isLoading = true

			let _self = this

			var data = new FormData();
			data.append('action', 'nl_get_works')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('xpage', this.gallery.xpage)
			data.append('current_page', this.gallery.pageNo)
			data.append('search', this.gallery.search)
			data.append('resolution_w', window.screen.availWidth)
			data.append('yearStr', this.yearStr)

			axios.post(url, data)
				.then((response) => {
					// console.log(response.data)
					if (response.data.gallery_elements.length) {
						this.gallery.elements = this.gallery.elements.concat(response.data.gallery_elements)
					} else {
						this.msgGallery1 = response.data.msg
					}
					this.isLoading = false
					this.gallery.isEnd = response.data.disable_btn == 1 ? true : false
				}, (error) => {
					this.isLoading = false
					console.log(error);
				});
		},

		getTextGalleryElements() {
			let url = this.ajaxObj.ajax_url
			this.isLoadingTwo = true

			let _self = this

			var data = new FormData();
			data.append('action', 'nl_get_text_works')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('xpage', this.textGallery.xpage)
			data.append('current_page', this.textGallery.pageNo)
			data.append('search', this.textGallery.search)
			data.append('resolution_w', window.screen.availWidth)
			data.append('yearStr', this.yearStr)

			axios.post(url, data)
				.then((response) => {
					// console.log(response.data)
					if (response.data.gallery_elements.length) {
						this.textGallery.elements = this.textGallery.elements.concat(response.data.gallery_elements)
					} else {
						this.msgGallery2 = response.data.msg
					}
					this.isLoadingTwo = false
					this.textGallery.isEnd = response.data.disable_btn == 1 ? true : false
				}, (error) => {
					this.isLoadingTwo = false
					console.log(error);
				});
		},

		gallerySearch() {
			this.gallery.elements = []
			this.getGalleryElements()
		},

		textGallerySearch() {
			this.textGallery.elements = []
			this.getTextGalleryElements()
		},

		loadMore() {
			this.gallery.pageNo = this.gallery.pageNo + 1
			this.getGalleryElements()
		},

		loadMoreTextGallery() {
			this.textGallery.pageNo = this.textGallery.pageNo + 1
			this.getTextGalleryElements()
		},

		resetSearch(gllr) {
			if(gllr == '1') {
				this.gallery.search = ''
				this.gallery.pageNo = 1
				this.getGalleryElements()
			} else if(gllr == '2') {
				this.textGallery.search = ''
				this.textGallery.pageNo = 1
				this.getTextGalleryElements()
			}
		}
	},

	created() {
		let uri = window.location.search.substring(1);
		let params = new URLSearchParams(uri);
		//console.log(params.get("g"));
		if(params.get("g") == 't') {
			setTimeout(() => {
				const section = document.getElementById('text-gallery-container')
				section.scrollIntoView({behavior: 'smooth'});
			}, 1000);
		}
	},

	mounted() {
		this.themeUrl = urlBase + themeDir
		this.getGalleryElements()
		this.getTextGalleryElements()

	}

}
</script>

<style scoped>
.vid-container {
	width: 100%;
	/*padding-top: 1920px / 1080px * 100%;*/
	position: relative;
	background-repeat: no-repeat;
	background-position: center;
	background-size: contain;
}
.vid-inner {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	padding: 12.3% 6.7%;
}

.vid-inner-inner {
	display: flex;
	align-items: center;
	width: 100%;
	height: 100%;
	background-color:black;
}
.vid-inner-inner video {
		width: 100%;
		max-height: 100%;
		/*object-fit: cover;*/
}
.wrk-title {text-transform: uppercase;}
.btn-black:hover, .btn-black:focus {border-color: #fff;}
input, input:focus, input:hover {
	border: 0;
	border-bottom: 4px solid #ffffff;
	background-color: #000000;
	color: #ffffff;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #ffffff;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: #ffffff;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: #ffffff;
}
@media (max-width: 1200px) {
	.container {
		width: 100%;
	}
}
</style>
